import React, { useState } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import Select from 'react-select';
import { PrimaryButton, SecondaryButton } from '../../_core/_ui/buttons.component';
import { IConcludePlayerOptions } from '../types/conclude-player-options.types';

interface IConcludePlayerComponent {
  sendNotifications: boolean;
  setSendNotifications: Function;
  concludePlayers: ClickHandler;
  concludeEmailTemplate: string;
  setConcludeEmailTemplate: Function;
  concludeEmailTemplateOptions: IConcludePlayerOptions[];
  closeModal: Function
}
const ConcludePlayerComponent: React.FC<IConcludePlayerComponent> = ({ concludePlayers, setConcludeEmailTemplate, setSendNotifications, sendNotifications, concludeEmailTemplate, concludeEmailTemplateOptions, closeModal }) => {
  const buttonStyle = { minWidth: '130px', marginLeft: '16px', marginTop: 1 }

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConcludeEmailTemplate((event.target as HTMLInputElement).value);
  };

  const selectedTemplate = concludeEmailTemplateOptions.find(option => option.value === concludeEmailTemplate);

  return (
    <>
      <Box width="500px">
        <Box width="100%" mb={2}>
          <FormControlLabel control={<Checkbox onClick={(e) => setSendNotifications(!sendNotifications)} /> } label="Send Email & Txt Notifications" />
        </Box>

        <Box width="100%" display={sendNotifications ? 'block' : 'none'} mb={2}>
          <FormControl disabled={!sendNotifications} fullWidth style={{ marginTop: 1, marginBottom: 1 }}>
            <FormLabel>Select the Email Template that will be used to notify the player</FormLabel>
            <RadioGroup
              aria-labelledby="conclude-email-template"
              name="conclude-email-template"
              value={concludeEmailTemplate}
              onChange={handleRadioChange}
            >
              {
                concludeEmailTemplateOptions.map(option => {
                  return (
                    <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={
                      <Box>
                        {option.label}
                      </Box>
                    } />
                  )
                })
              }
            </RadioGroup>
          </FormControl>

          <Box width="100%">
            Preview:<br/>

            <Typography><strong>Subject:</strong> {selectedTemplate?.subjectLine}</Typography><br/>

            <img width="100%" src={selectedTemplate?.preview} />
          </Box>
        </Box>

        <PrimaryButton
          style={buttonStyle}
          onClick={concludePlayers}
        >Conclude</PrimaryButton>
        <SecondaryButton onClick={() => closeModal()}>
          Cancel
        </SecondaryButton>
      </Box>
    </>
  );
}

export default ConcludePlayerComponent;